import { render } from "./MappingsPreview.vue?vue&type=template&id=e0d7989e&scoped=true"
import script from "./MappingsPreview.vue?vue&type=script&lang=ts"
export * from "./MappingsPreview.vue?vue&type=script&lang=ts"

import "./MappingsPreview.vue?vue&type=style&index=0&id=e0d7989e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e0d7989e"

export default script